import { AbstractControl, FormArray, FormControl, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { MultiShipmentExtension } from '@pdqdev/pdq-shared/dist/interfaces/ICheckoutExtensions';
import {
  DatePickerConfigurationValue,
  defaultDatePickerConfigurationValue,
} from '@app/sharedModule/components/date-picker-configuration/date-picker-configuration.types';

export interface DatePickerProfileForm {
  name: FormControl<string>;
  enabled: FormControl<boolean>;
  configuration: FormControl<DatePickerConfigurationValue>;
}

function uniqueProfileNameValidator(nameControl: AbstractControl): ValidationErrors | null {
  const profilesArray = nameControl.parent?.parent as FormArray | null;
  if (!profilesArray) {
    return null;
  }
  const name = (nameControl.value ?? '').trim().toLowerCase();
  if (!name) {
    return null;
  }
  const duplicatesAnother = profilesArray.controls.some(
    (profile) =>
      profile !== nameControl.parent && ((profile.get('name')?.value ?? '') as string).trim().toLowerCase() === name,
  );
  return duplicatesAnother ? { duplicateName: true } : null;
}

export function createDatePickerProfileForm(
  value?: Partial<MultiShipmentExtension.DatePickerProfile>,
): FormGroup<DatePickerProfileForm> {
  return new FormGroup<DatePickerProfileForm>({
    name: new FormControl(value?.name ?? 'Date picker profile 1', {
      nonNullable: true,
      validators: [Validators.required, uniqueProfileNameValidator],
    }),
    enabled: new FormControl(value?.enabled ?? true, { nonNullable: true }),
    configuration: new FormControl(value?.configuration ?? defaultDatePickerConfigurationValue(), {
      nonNullable: true,
    }),
  });
}

export function createDatePickerProfilesArray(
  loadedProfiles?: MultiShipmentExtension.DatePickerProfile[],
): FormArray<FormGroup<DatePickerProfileForm>> {
  const profiles = loadedProfiles
    ? loadedProfiles.map((profile) => createDatePickerProfileForm(profile))
    : [createDatePickerProfileForm()];
  return new FormArray<FormGroup<DatePickerProfileForm>>(profiles);
}
